import TagInput from "./TagInput"

const AssetRow = ({ asset, onToggleSelect, onUpdateAdSets, campaignNames, adAndAdsetMapping }) => {
  return (
    <div
      className={`grid grid-cols-12 gap-4 py-4 border-b ${
        asset.selected ? "" : ""
      } transition-colors duration-200`}
    >
      <div className="col-span-1 flex items-center justify-center">
        <input
          type="checkbox"
          checked={asset.selected}
          onChange={() => onToggleSelect(asset.id)}
          className="w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500 transition-all cursor-pointer"
        />
      </div>
      <div className="col-span-3 flex items-center justify-center">
        <div className="w-24 h-24 bg-gray-200 rounded-md overflow-hidden">
          <img
            src={asset.imageUrl}
            alt="Asset"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="col-span-3">
        <div className="h-full">
          <span className="break-words">{asset.name}</span>
        </div>
      </div>
      <div className="col-span-4">
        <div className="h-full">
          <TagInput
            tags={asset.adSets}
            onUpdateAdSets={(adSets) => onUpdateAdSets(asset.id, adSets)}
            placeholder="Add ad set..."
            campaignNames={campaignNames}
            adAndAdsetMapping={adAndAdsetMapping}
          />
        </div>
      </div>
    </div>
  )
}

export default AssetRow
